module.exports = __webpack_public_path__ + "media/icons/up-table-arrow-9317c8e1.png";